import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import Verrou from './composants/Verrou.jsx';
import './themes.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* Le verrou enveloppe l'application entière : rien de ce qui lit la base
        n'est monté tant qu'il n'a pas cédé. */}
    <Verrou>
      <App />
    </Verrou>
  </React.StrictMode>
);
